import { useQuery } from "@tanstack/react-query";
import { axios } from "../../../shared/lib/axios";
import { useEnrollment } from "../../courses/api/getEnrollment";

export const getStudentEvaluationResults = async (params) => {
  const res = await axios.apiCadernoVirtual("/survey-service/survey/result", {
    params,
  });

  return res.object;
};

export const useStudentEvaluationResults = ({
  config,
  params = {},
  surveyId,
  courseId,
  enrollmentParams,
} = {}) => {
  const enrollmentQuery = useEnrollment({
    params: { courseId, ...enrollmentParams },
  });

  return useQuery({
    ...config,
    enabled: enrollmentQuery.isSuccess,
    queryKey: [
      "evaluationResults",
      {
        surveyId,
        registerId: enrollmentQuery.data?.MATRICULAID,
        ...params,
      },
    ],
    queryFn: () =>
      getStudentEvaluationResults({
        surveyId,
        registerId: enrollmentQuery.data?.MATRICULAID,
        ...params,
      }),
  });
};
